<cs-icon-button
  class="btn-back"
  iconType="icon"
  icon="fi-arrow-left"
  color="secondary"
  size="12"
  (buttonClick)="goBack()"
></cs-icon-button>
<div class="heading">Saved addresses</div>
<div class="cont">
  @if (addressList.length === 0 && !addressLoading) {
    <div class="empty-wrap">
      <app-empty
        [title]="'Oops... There\'s no address to display'"
        [message]="'Save your addresses to make future withdrawals easier. Add notes to keep them organized.'"
      ></app-empty>
    </div>
  } @else {
    <div class="address-list">
      @for (item of addressList; track item.address) {
        <div class="item">
          <div class="name">{{ item.remark }}</div>
          <div>
            <span class="address">{{ walletService.shortenAddress(item.address) }}</span>
            <div class="btn" (click)="onOpenCancel(item.id)">
              <i class="fi-trash-filled"></i>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <cs-button
    label="Save new address"
    [disabled]="addressList.length >= 5"
    size="large"
    color="third"
    (buttonClick)="goAddEditAddress()"
  ></cs-button>
  @if (addressList.length >= 5) {
    <div class="note">You can’t save more than 5 addresses.</div>
  }
</div>
